<div class="inline-questions">
  @if (outputText()) {
    <p class="inline-questions__output">{{ outputText() }}</p>
  }

  @for (question of questions(); track question.id) {
    <div class="inline-questions__group">
      <span class="inline-questions__label" [id]="question.id + '-label'">{{ question.text }}</span>
      @if (question.type === 'text') {
        <div class="inline-questions__text-row">
          <input
            class="inline-questions__text-input"
            type="text"
            placeholder="Type your answer..."
            [value]="getTextValue(question.id)"
            (input)="onTextInput(question.id, $event)"
          />
          <mat-chip-listbox (change)="onChipChange(question.id, $event)">
            <mat-chip-option
              value="Skip"
              [selected]="isSelected(question.id, 'Skip')"
              class="inline-questions__skip-chip"
            >
              Skip
            </mat-chip-option>
          </mat-chip-listbox>
        </div>
      } @else if (question.type === 'choice' && question.options?.length) {
        <div class="inline-questions__choice-group" role="radiogroup" [attr.aria-labelledby]="question.id + '-label'">
          @for (option of question.options; track option) {
            <label
              class="inline-questions__choice-option"
              [class.inline-questions__choice-option--checked]="isSelected(question.id, option)"
            >
              <span class="inline-questions__choice-control">
                <input
                  class="inline-questions__choice-input"
                  type="radio"
                  [name]="question.id"
                  [value]="option"
                  [checked]="isSelected(question.id, option)"
                  (change)="onChoiceChange(question.id, option)"
                />
              </span>
              <span class="inline-questions__choice-text">{{ option }}</span>
            </label>
          }
        </div>
        <mat-chip-listbox (change)="onChipChange(question.id, $event)">
          <mat-chip-option
            value="Skip"
            [selected]="isSelected(question.id, 'Skip')"
            class="inline-questions__skip-chip"
          >
            Skip
          </mat-chip-option>
        </mat-chip-listbox>
      } @else {
        <mat-chip-listbox (change)="onChipChange(question.id, $event)">
          @if (question.type === 'confirm') {
            <mat-chip-option value="Yes" [selected]="isSelected(question.id, 'Yes')">Yes</mat-chip-option>
            <mat-chip-option value="No" [selected]="isSelected(question.id, 'No')">No</mat-chip-option>
          }
          <mat-chip-option
            value="Skip"
            [selected]="isSelected(question.id, 'Skip')"
            class="inline-questions__skip-chip"
          >
            Skip
          </mat-chip-option>
        </mat-chip-listbox>
      }
    </div>
  }

  <div class="inline-questions__actions">
    <button mat-stroked-button (click)="onCancel()" type="button">Cancel</button>
    <button
      mat-flat-button
      class="inline-questions__continue-btn"
      [disabled]="!allAnswered()"
      (click)="onContinue()"
      type="button"
    >
      Continue
    </button>
  </div>
</div>
